import request from './request'
 
export function getNowOrderList(query) {
  return request({
    url: '/wxApp/parking/getParkingList',
    method: 'get',
    params: query
  })
}

export function getParkingGateList(query) {
  return request({
    url: '/boxApp/gate/getParkingGateList',
    method: 'get',
    params: query
  })
}

export function getDeviceFLV(query) {
  return request({
    url: '/box/getDeviceFLV',
    method: 'get',
    params: query
  })
}

export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get',
  })
}

export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/boxApp/login',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    data: data
  })
}



export function getInfo() {
  return request({
    url: '/boxApp/getInfo',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

export function getOrderInfo(query) {
  return request({
    url: '/box/getOrderInfo',
    method: 'get',
    params: query
  })
}

export function outOpenGate(data) {
  return request({
    url: '/box/outOpenGate',
    method: 'post',
    data: data
  })
}

export function updateOrderMoney(data) {
  return request({
    url: '/box/updateOrderMoney',
    method: 'post',
    data: data
  })
}

export function snapPhoto(gateNo) {
  return request({
    url: '/boxApp/gate/snapPhoto/' + gateNo,
    method: 'post',
  })
}

export function rectifyPlateNo(data) {
  return request({
    url: '/box/rectifyPlateNo',
    method: 'post',
    data: data
  })
}

export function noPlateNoOutOpenGate(data) {
  return request({
    url: '/box/noPlateNoOutOpenGate',
    method: 'post',
    data: data
  })
}

export function vehicleRegistration(data) {
  return request({
    url: '/box/vehicleRegistration',
    method: 'post',
    data: data
  })
}

export function updatePwd(data) {
  return request({
    url: '/boxApp/updatePwd',
    method: 'post',
    data: data
  })
}









 